import { render, staticRenderFns } from "./Webradar.vue?vue&type=template&id=b1a4278c&scoped=true&"
import script from "./Webradar.vue?vue&type=script&lang=js&"
export * from "./Webradar.vue?vue&type=script&lang=js&"
import style0 from "./Webradar.vue?vue&type=style&index=0&id=b1a4278c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a4278c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
